<script>
  export default {
    methods: {
      async fetchData(url, method, body, authenticate, json) {
        const options =  {
          method,
          headers: {
            'Content-Type': json ? 'application/json' : 'application/x-www-form-urlencoded',
            'charset': 'utf-8',
          },
          mode: 'cors',
          credentials: 'include'
        }
        if(body !== null) {
          options.body = json ? body : new URLSearchParams(body)
        }
        if(authenticate) {
          if(this.getCook('accessToken') === '') {
            await this.getAccessToken().then(async() => {
            await this.relog();
            const encodedCredentials = this.getCook('accessToken')
            options.headers['Authorization'] = `Bearer ${encodedCredentials}`
              if(process.env.NODE_ENV === 'development') {
                return fetch('http://localhost:5000/api' + url, options)
              } else {
                return fetch(location.protocol + '//' + location.host + '/api' + url, options)
              }
            })
          } else {
            const encodedCredentials = this.getCook('accessToken')
            options.headers['Authorization'] = `Bearer ${encodedCredentials}`;
          }
          
        }

        if(process.env.NODE_ENV === 'development') {
          return fetch('http://localhost:5000/api' + url, options)
        } else {
          return fetch('/api' + url, options)
        }
      },
      getCook(cookiename) {
        // Get name followed by anything except a semicolon
        var cookiestring = RegExp(cookiename+"=[^;]+").exec(document.cookie);
        // Return everything after the equal sign, or an empty string if the cookie name not found
        return decodeURIComponent(cookiestring ? cookiestring.toString().replace(/^[^=]+./,"") : "");
      },
      async relog() {
        const encodedCredentials = this.getCook('accessToken')
        const userId = this.$store.state.user.id
        if(process.env.NODE_ENV !== "development") {
          await fetch(location.protocol + '//' + location.host + '/api' + `/users/get-current-user-creds?id=${userId}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'charset': 'utf-8',
              'Authorization': `Bearer ${encodedCredentials}`
            },
            mode: 'cors',
            credentials: 'include'
          }).then(res => {
            return res.json()
          }).then(data => {
            if(data.result !== undefined && data.result.length > 0) {
              if(this.$store.state.user.roleId !== data.result[0].roleId) {
                localStorage.removeItem('_rToken')
                document.cookie = 'accessToken=; Max-Age=-99999999'
                this.$router.push('/');
              }
            } else {
              console.error(data.msg);
            }
          })
        } else {
          await fetch(`http://localhost:5000/api/users/get-current-user-creds?id=${userId}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'charset': 'utf-8',
              'Authorization': `Bearer ${encodedCredentials}`
            },
            mode: 'cors',
            credentials: 'include'
          }).then(res => {
            return res.json()
          }).then(data => {
            if(data.result !== undefined && data.result.length > 0) {
              if(this.$store.state.user.roleId !== data.result[0].roleId) {
                localStorage.removeItem('_rToken')
                document.cookie = 'accessToken=; Max-Age=-99999999'
                this.$router.push('/');
              }
            } else {
              console.error(data.msg);
            }
          })
        }
      },
      async getAccessToken() {
        if(process.env.NODE_ENV !== "development") {
          await fetch(location.protocol + '//' + location.host + '/api' + '/auth/token', {
            method: 'POST',
            mode: 'cors',
            headers: {
              'Content-Type': 'application/json',
              'charset': 'utf-8'
            },
            credentials: 'include',
            body: JSON.stringify({token: window.localStorage.getItem('_rToken')})
          }).then(res => {
            if(res.ok) {
              return res.json()
            }
          }).then(data => {
            var now = new Date();
            var time = now.getTime();
            var expireTime = time + (1000 * 60 * 20) // 20 mins
            now.setTime(expireTime)
            document.cookie = `accessToken=${data.accessToken};expires=${now.toUTCString()};SameSite=None; Secure`
          })
        } else {
          await fetch('http://localhost:5000/api/auth/token', {
            method: 'POST',
            mode: 'cors',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'charset': 'utf-8'
            },
            credentials: 'include',
            body: new URLSearchParams({token: window.localStorage.getItem('_rToken')})
          }).then(res => {
            if(res.ok) {
              return res.json()
            }
          }).then(data => {
            var now = new Date();
            var time = now.getTime();
            var expireTime = time + (1000 * 60 * 20) // 20 mins
            now.setTime(expireTime)
            document.cookie = `accessToken=${data.accessToken};expires=${now.toUTCString()};SameSite=None; Secure`
          })
        }
      },
    }
  }
</script>